import { useMemo } from 'react';
import {
  CollectorScope,
  CompanyCollectorsQuery,
  useCompanyCollectorsQuery
} from 'graphql/types';

export const useCompanyCollectors = (
  scope: CollectorScope
): {
  data: CompanyCollectorsQuery | undefined;
  loading: boolean;
} => {
  const { loading, data } = useCompanyCollectorsQuery({
    variables: {
      input: { scope }
    }
  });

  return useMemo(
    () => ({
      loading,
      data
    }),
    [data, loading]
  );
};
